export enum AccountMenuItem {
    personalInfo = 'personal-info',
    payments = 'payments',
    purchaseHistory = 'purchase-history',
}

export enum SupportMenuItem {
    support = 'support',
    messages = 'messages',
}

export enum UnityDocumentType {
    privacy = 'privacy',
    terms = 'terms',
}

export enum GaCategories {
    loginFlow = 'Login Flow',
    purchaseFlow = 'Purchase Flow',
}

export enum GaEvents {
    loginViewed = 'login_screen_viewed',
    phoneEntered = 'phone_number_entered',
    verificationSent = 'verification_code_sent',
    verificationEntered = 'verification_code_entered',
    loginSuccess = 'login_success',
    loginFailed = 'login_failed',
    storeViewed = 'store_screen_viewed',
    allOffersClicked = 'view_all_offers_clicked',
    productSelected = 'product_selected',
    checkoutStarted = 'checkout_started',
    paymentInfoEntered = 'payment_info_entered',
    purchaseInitiated = 'purchase_initiated',
    purchaseSuccess = 'purchase_success',
}
